import { IssueStatus } from 'shared'
import CIMSFormItem from 'components/CIMSFormItem'
import CIMSTextArea from 'components/CIMSTextArea'
import { useValidateWhitespaceProps } from 'components/CIMSTextArea/hooks/useValidateWhitespaceProps'
import { FormItemProps } from '../types'
import { HelpMessage } from 'utils/constants'

const DispositionNotes: React.VFC<FormItemProps> = ({ from, to }) => {
  const props = useValidateWhitespaceProps({
    label: 'Disposition Notes',
    required: to === IssueStatus.PendingClosure.id ? true : undefined,
  })
  if (
    from === IssueStatus.PendingDisposition.id ||
    from === IssueStatus.PendingResponse.id
  )
    return null
  return (
    <CIMSFormItem
      help={HelpMessage.Issues.IssueTracker.DispositionNotes}
      name="dispositionNotes"
      {...props}
    >
      <CIMSTextArea maxLength={2000} />
    </CIMSFormItem>
  )
}

export default DispositionNotes
